<atom-async-data
    [isLoading]="isPreLoading || !(data$ | ngrxPush)"
    [overlayContent]="isPreLoading"
>
    @if (formDetails$ | ngrxPush; as formDetails) {
        @if (formDetails?.lock) {
            <div>
                <wdx-ff-lock-summary [formData]="formDetails">
                </wdx-ff-lock-summary>
            </div>
        }
        @if (summaryInfoCards$ | ngrxPush; as summaryInfoCards) {
            @if (summaryInfoCards?.length) {
                <div class="mt-2">
                    <wdx-ff-summary-info-cards
                        [infoCards]="summaryInfoCards"
                    ></wdx-ff-summary-info-cards>
                </div>
            }
        }
        @if (formDetails?.pendingChanges?.length) {
            <wdx-ff-pending-changes
                [showButton]="false"
                [pendingChanges]="formSummaryPendingChangesService?.coc"
                [pendingChangesSubForm]="
                    formSummaryPendingChangesService?.pendingChangesSubFormCounter
                "
                (wdxOnClick)="onClickEvent(FORM_SUMMARY_CHANGE_OF_CIRCUMSTANCE)"
            ></wdx-ff-pending-changes>
        }
        @if (layoutDefinition$ | ngrxPush; as layoutDefinition) {
            @if (layoutDefinition) {
                <organism-form-summary-content
                    [entityId]="entityId"
                    [layoutDefinition]="layoutDefinition"
                    [definition]="definition$ | ngrxPush"
                    [data]="data$ | ngrxPush"
                    [formDetails]="formDetails"
                    [subFormData]="subFormData$ | ngrxPush"
                >
                </organism-form-summary-content>
            }
        }
    }
</atom-async-data>
